import * as React from 'react';
import { cn } from '@/lib/utils';

const Label = React.forwardRef<HTMLLabelElement, React.LabelHTMLAttributes<HTMLLabelElement>>(
  ({ className, ...props }, ref) => (
    <label
      ref={ref}
      className={cn('block text-[11px] font-bold text-muted-foreground uppercase tracking-widest', className)}
      {...props}
    />
  )
);
Label.displayName = 'Label';

export { Label };
